// Pure formatting + date helpers. No React, no data dependency.

export function fmtMin(m) {
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h === 0) return `${mm}min`;
  if (mm === 0) return `${h}h`;
  return `${h}h ${mm}m`;
}

export function fmtEuro(n) {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n);
}

export function fmtDeadline(deadline) {
  if (!deadline) return '—';
  const d = new Date(deadline);
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function deadlineDaysLeft(deadline, ref = new Date()) {
  if (!deadline) return null;
  const d = new Date(deadline);
  return Math.ceil((d - ref) / (1000 * 60 * 60 * 24));
}

export function pad(n) { return String(n).padStart(2, '0'); }

// time strings "HH:MM" or "HH:MM:SS"
export function timeToMin(t) {
  if (!t) return 0;
  const [h, m] = t.split(':').map(Number);
  return h * 60 + (m || 0);
}

export function minToTime(m) {
  return `${pad(Math.floor(m / 60))}:${pad(m % 60)}`;
}

// Minutes between two "HH:MM" times on the same day.
export function durationMin(from, to) {
  return timeToMin(to) - timeToMin(from);
}

const DAY_NAMES = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
export function dayName(d = new Date()) { return DAY_NAMES[d.getDay()]; }

export function todayIso(d = new Date()) {
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
}

// Returns the currently-active absence row for a user on a given date,
// or null if they're available. Used to gray out rows + show emoji badges.
export function currentAbsence(userId, absences, date = new Date()) {
  if (!absences || absences.length === 0) return null;
  const iso = isoFromDate(date);
  for (const a of absences) {
    if (a.user_id !== userId) continue;
    if (iso >= a.start_date && iso <= a.end_date) return a;
  }
  return null;
}

// Capitalise the first letter of every word. Profiles seeded from email
// addresses (signup default) are lowercase; this fixes the display.
export function capitalizeName(name) {
  if (!name) return '';
  return name.split(/(\s+)/).map(part => {
    if (!part || !/\S/.test(part)) return part;
    return part[0].toUpperCase() + part.slice(1);
  }).join('');
}

// Date utilities for week-based views
export function isoFromDate(d) {
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
}

export function startOfWeek(d = new Date()) {
  const day = d.getDay();              // 0=Sun .. 6=Sat
  const offset = day === 0 ? -6 : 1 - day;
  const s = new Date(d);
  s.setDate(d.getDate() + offset);
  s.setHours(0, 0, 0, 0);
  return s;
}

export function isoWeekNumber(d) {
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  return Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
}
